window.casino = window.casino || {};
var repos = window.casino.repos = window.casino.repos || {};


repos.pokerPrvenstvoHrvatskePobjedniciRepo = function () {

    var url = 'api/PokerPrvenstvoHrvatskePobjednici';

    var list = function (turnir) {

        return fetch(url + casino.repos.base.serializeGetParams(turnir))
            .then(casino.repos.base.checkResponse)
            .then(function (response) {
                return response.json();
            })
            .catch(casino.repos.base.handleNetworkException);
    };

    return {
        list: list
    }

}();